import React, { useEffect, useState } from "react";
import {
  OtherTreatmentsForm,
  OtherTreatmentsProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";

const OtherTreatments: React.FC<OtherTreatmentsProps> = ({ onChange }) => {
  const [form, setForm] = useState<OtherTreatmentsForm>({
    requirement: "",
  });

  const handleChange = (field: keyof OtherTreatmentsForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        OTHER TREATMENTS
      </h2>

      <div className="w-[100%] md:w-[90%]">
        <TextInput
          label="Please specify requirement"
          name="requirement"
          value={form.requirement}
          onChange={(e) => handleChange("requirement", e.target.value)}
        />
      </div>
    </div>
  );
};

export default OtherTreatments;
